import React, { useEffect, useState } from 'react';

import classes from './shareBlock.module.scss';

import ShareLogo from '@/assets/svg/share.svg';
import CloseLogo from '@/assets/svg/close.svg';
import VK from '@/assets/svg/vk.svg';
import TG from '@/assets/svg/tg.svg';
import OK from '@/assets/svg/ok.svg';
import { SocialId } from '@/utils/constant';
import { analytics, AnalyticsShow } from '@/utils/analytics';
import ClickOutside from '@/helpers/ClickOutside';
import share from '@/helpers/share';

type ShareBlockProps = {
    foldable?: boolean;
    result?: boolean;
};

export const ShareBlock = ({ foldable = true, result = false }: ShareBlockProps) => {
    const [opened, setOpened] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!foldable) return;
        if (!opened) return;

        const toggle = () => setOpened(false);

        window.addEventListener('click', toggle, { capture: true });
        return () => window.removeEventListener('click', toggle, { capture: true });
    }, [opened, foldable]);

    const toggleOpened = () => setOpened(!opened);

    if (!mounted) return null;

    if (foldable) {
        return (
            <div className={`${classes.shareBlock} ${opened ? classes.opened : ''}`}>
                {opened ? (
                    <button className={`${classes.visible} `}>
                        <CloseLogo
                            onClick={() => {
                                toggleOpened();
                            }}
                        />
                    </button>
                ) : (
                    <button className={`${classes.visible} `}>
                        <ShareLogo
                            onClick={() => {
                                toggleOpened();
                            }}
                        />
                    </button>
                )}
                <ClickOutside
                    className={classes.hiddenWrapper}
                    onClickOutside={() => {
                        if (opened) setOpened(false);
                    }}
                >
                    <div className={classes.hidden}>
                        <div className={classes.list}>
                            <a
                                className={classes.vk}
                                href={share(SocialId.Vk, mounted, result)}
                                suppressHydrationWarning
                                onClick={() => {
                                    switch (result) {
                                        default:
                                            return analytics(
                                                result
                                                    ? AnalyticsShow.ShareVK
                                                    : AnalyticsShow.ShareVK,
                                            );
                                    }
                                }}
                            >
                                <VK className={''} />
                            </a>
                            <a
                                className={classes.telegram}
                                href={share(SocialId.Tg, mounted, result)}
                                suppressHydrationWarning
                                onClick={() => {
                                    switch (result) {
                                        default:
                                            return analytics(
                                                result
                                                    ? AnalyticsShow.ShareTG
                                                    : AnalyticsShow.ShareTG,
                                            );
                                    }
                                }}
                            >
                                <TG className={''} />
                            </a>
                            <a
                                className={classes.ok}
                                href={share(SocialId.Ok, mounted, result)}
                                suppressHydrationWarning
                                onClick={() => {
                                    switch (result) {
                                        default:
                                            return analytics(
                                                result
                                                    ? AnalyticsShow.ShareOK
                                                    : AnalyticsShow.ShareOK,
                                            );
                                    }
                                }}
                            >
                                <OK className={''} />
                            </a>
                        </div>
                    </div>
                </ClickOutside>
            </div>
        );
    } else {
        return (
            <div className={classes.shareList}>
                <a
                    className={classes.vk}
                    href={share(SocialId.Vk, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareVK);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social`}
                        // onClick={() => adFox('', '', !isResult ? 'shareVK' : 'shareResultVK')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <VK className={''} />
                            </div>
                        </div>
                    </div>
                </a>
                <a
                    className={classes.telegram}
                    href={share(SocialId.Tg, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareTG);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social offset`}
                        // onClick={() => adFox('', !isResult ? 'shareTG' : 'shareResultTG')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <TG className={''} />
                            </div>
                        </div>
                    </div>
                </a>
                <a
                    className={classes.ok}
                    href={share(SocialId.Ok, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareOK);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social`}
                        // onClick={() => adFox('', !isResult ? 'shareOK' : 'shareResultOK')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <OK className={''} />
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        );
    }
};
